var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comulative-row"},[_c('label',{staticClass:"comulative-flag",class:{
      'is-comulative': _vm.data.isComulative
    }},[_vm._v("\n    "+_vm._s(_vm.data.isComulative ? 'Obligatorio' : 'Opcional')+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }